export enum OrderedEnum {
  NEW_OLD = 'NEW_OLD',
  PRICE = 'PRICE',
  POPULAR = 'POPULAR',
}
